import React from "react";

import {
  ManageBreakdowns,
  Tabs,
  FiltersProvider,
} from "@features/breakdown-v2";

export const BreakdownsPage = () => {
  return (
    <div className="p-6">
      <Tabs />
      <FiltersProvider>
        <ManageBreakdowns />
      </FiltersProvider>
    </div>
  );
};
